(() => {
  const root = window.Shopify?.routes?.root || '/';
  const drawers = document.querySelectorAll('[data-drawer]');
  const overlay = document.querySelector('[data-drawer-overlay]');
  let lastTrigger = null;
  let searchTimer;

  const money = (amount) => `<span class="picky-money"><img class="picky-dirham" src="https://cdn.shopify.com/s/files/1/0847/6531/1219/files/official-dirham-symbol.png?v=1791828626" alt="AED" width="22" height="22"><span>${new Intl.NumberFormat(document.documentElement.lang || 'en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount / 100)}</span></span>`;
  const searchPrice = (price) => typeof price === 'number' ? money(price) : money(Number(String(price || '').replace(/[^0-9.]/g, '')) * 100);

  const imageFor = (item) => {
    let handle = item.handle;
    if (!handle && item.url) { try { handle = decodeURIComponent(item.url.split('/products/')[1]?.split('?')[0] || ''); } catch (_) {} }
    return window.PickyPaddleImages?.[handle]?.default?.src || item.image || '';
  };
  const applyImageAlignment = (image, data) => {
    ['h', 'x', 'y'].forEach(axis => { const value = data['clean' + axis.toUpperCase()]; if (value) image.style.setProperty('--clean-' + axis, value + '%'); });
  };

  const wishlistKey = 'picky-wishlist';
  const getWishlist = () => {
    try { return JSON.parse(localStorage.getItem(wishlistKey) || '[]').map(String); }
    catch (_) { return []; }
  };
  const syncWishlistButtons = () => {
    const saved = new Set(getWishlist());
    document.querySelectorAll('[data-wishlist-id]').forEach((button) => {
      const active = saved.has(String(button.dataset.wishlistId));
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', `${active ? 'Remove' : 'Add'} ${button.dataset.wishlistTitle || 'product'} ${active ? 'from' : 'to'} wishlist`);
      const icon = button.querySelector('span');
      if (icon) icon.textContent = active ? '♥' : '♡';
    });
  };
  const toggleWishlist = (button) => {
    const id = String(button.dataset.wishlistId);
    const saved = new Set(getWishlist());
    saved.has(id) ? saved.delete(id) : saved.add(id);
    try { localStorage.setItem(wishlistKey, JSON.stringify([...saved])); } catch (_) {}
    syncWishlistButtons();
  };

  const updateBenchPages = (section) => {
    const pagination = section.querySelector('[data-bench-pagination]');
    if (!pagination) return;
    const count = [...section.querySelectorAll('.picky-bench-card')].filter(card => !card.hidden).length;
    const perPage = window.innerWidth < 990 ? 1 : 3;
    const pages = Math.ceil(count / perPage);
    pagination.hidden = pages < 2;
    pagination.innerHTML = Array.from({ length: pages }, (_, page) => `<button type="button" data-bench-page="${page}" aria-label="Show product page ${page + 1}"${page === 0 ? ' class="is-active" aria-current="true"' : ''}></button>`).join('');
  };

  const revealHeadingSelector = '.picky-hero h1, .picky-section-heading h2, .picky-heading-row h2, .picky-feature h2, .picky-quiz h2, .picky-newsletter h2, .picky-collection__header h1, .picky-pdp__info h1, .picky-page h1, .picky-blog h1, .picky-article h1';
  const headingObserver = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? null : new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
  const initHeadingReveals = (scope = document) => {
    scope.querySelectorAll(revealHeadingSelector).forEach((heading) => {
      if (heading.dataset.revealReady) return;
      heading.dataset.revealReady = 'true';
      if (!headingObserver) { heading.classList.add('is-visible'); return; }
      heading.classList.add('picky-reveal-heading');
      headingObserver.observe(heading);
    });
  };
  const dawnImageSelector = '.picky-hero__media, .picky-feature__art, .picky-review img, .picky-pdp__main-media, .picky-pdp__thumbs';
  const onDawnIntersection = (elements, observer) => {
    elements.forEach((element, index) => {
      if (element.isIntersecting) {
        const target = element.target;
        if (target.classList.contains('scroll-trigger--offscreen')) {
          target.classList.remove('scroll-trigger--offscreen');
          if (target.hasAttribute('data-cascade')) target.style.setProperty('--animation-order', index);
        }
        observer.unobserve(target);
      } else {
        element.target.classList.add('scroll-trigger--offscreen');
        element.target.classList.remove('scroll-trigger--cancel');
      }
    });
  };
  const initDawnImageReveals = (scope = document) => {
    const visuals = [...scope.querySelectorAll(dawnImageSelector)].filter((visual) => !visual.dataset.dawnRevealReady);
    if (!visuals.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const observer = new IntersectionObserver(onDawnIntersection, { rootMargin: '0px 0px -50px 0px' });
    visuals.forEach((visual, index) => {
      visual.dataset.dawnRevealReady = 'true';
      visual.classList.add('scroll-trigger', 'animate--slide-in');
      visual.setAttribute('data-cascade', '');
      visual.style.setProperty('--animation-order', index);
      observer.observe(visual);
    });
  };

  const escapeHtml = (value = '') => {
    const element = document.createElement('div');
    element.textContent = value;
    return element.innerHTML;
  };

  const initPaddleQuizzes = (scope = document) => {
    scope.querySelectorAll('[data-paddle-quiz]').forEach((quiz) => {
      if (quiz.dataset.quizReady) return;
      quiz.dataset.quizReady = 'true';
      const card = quiz.querySelector('.picky-quiz__card');
      const drawer = quiz.querySelector('[data-quiz-drawer]');
      const dialog = quiz.querySelector('.picky-quiz__drawer-dialog');
      const panel = quiz.querySelector('[data-quiz-panel]');
      const results = quiz.querySelector('[data-quiz-results]');
      const form = quiz.querySelector('[data-quiz-form]');
      const questions = [...quiz.querySelectorAll('[data-quiz-question]')];
      const back = quiz.querySelector('[data-quiz-back]');
      const next = quiz.querySelector('[data-quiz-next]');
      const error = quiz.querySelector('[data-quiz-error]');
      let step = 0;
      let closeTimer;
      const showStep = (index) => {
        step = index; questions.forEach((question, i) => { question.hidden = i !== step; });
        quiz.querySelector('[data-quiz-progress]').textContent = `Question ${step + 1} of ${questions.length}`;
        quiz.querySelector('[data-quiz-progress-bar]').style.width = `${((step + 1) / questions.length) * 100}%`;
        back.hidden = step === 0; next.textContent = step === questions.length - 1 ? 'See my matches' : 'Next'; error.hidden = true;
        questions[step]?.querySelector('input:checked, input')?.focus();
      };
      const showResults = () => {
        const answers = Object.fromEntries(new FormData(form).entries());
        const products = [...quiz.querySelectorAll('[data-quiz-product]')];
        const style = answers.style === 'balanced' ? 'all-court' : answers.style;
        const budget = answers.budget === 'any' ? Infinity : Number(answers.budget);
        const matches = products.filter(product => product.dataset.quizStyle === style && Number(product.dataset.quizPrice) <= budget)
          .sort((a, b) => Number(a.dataset.quizPrice) - Number(b.dataset.quizPrice));
        products.forEach(product => { product.hidden = true; });
        matches.slice(0, 3).forEach(product => {
          product.hidden = false;
          product.parentElement.appendChild(product);
          product.querySelector('[data-quiz-match]').textContent = `${style === 'all-court' ? 'All-court' : style[0].toUpperCase() + style.slice(1)} · ${budget === Infinity ? 'Your chosen style' : 'Within your budget'}`;
        });
        quiz.querySelector('[data-quiz-summary]').textContent = `${matches.length ? 'A shortlist for your ' + (style === 'all-court' ? 'all-court' : style) + ' game.' : 'No exact matches yet.'} Prices include VAT. Check each paddle’s availability below.`;
        quiz.querySelector('[data-quiz-empty]').hidden = matches.length > 0;
        panel.hidden = true; results.hidden = false; dialog.scrollTo({ top: 0, behavior: 'smooth' });
      };
      const openQuiz = () => {
        window.clearTimeout(closeTimer);
        quiz.quizReturnFocus = document.activeElement;
        drawer.hidden = false;
        drawer.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(() => drawer.classList.add('is-open'));
        document.body.classList.add('picky-quiz-open');
        results.hidden = true;
        panel.hidden = false;
        showStep(0);
        dialog.scrollTop = 0;
      };
      const closeQuiz = () => {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('picky-quiz-open');
        closeTimer = window.setTimeout(() => { drawer.hidden = true; quiz.quizReturnFocus?.focus?.(); }, 250);
      };
      quiz.pickyQuiz = { open: openQuiz, close: closeQuiz, drawer, dialog, panel, results };
      quiz.querySelector('[data-quiz-start]').addEventListener('click', openQuiz);
      quiz.querySelectorAll('[data-quiz-close]').forEach((button) => button.addEventListener('click', closeQuiz));
      next.addEventListener('click', () => { if (!questions[step].querySelector('input:checked')) { error.hidden = false; return; } step === questions.length - 1 ? showResults() : showStep(step + 1); });
      back.addEventListener('click', () => showStep(Math.max(0, step - 1)));
      form.addEventListener('submit', (event) => event.preventDefault());
      quiz.querySelectorAll('input').forEach((input) => input.addEventListener('change', () => { error.hidden = true; }));
      quiz.querySelector('[data-quiz-retake]').addEventListener('click', () => { form.reset(); results.hidden = true; panel.hidden = false; showStep(0); dialog.scrollTo({ top: 0, behavior: 'smooth' }); });
    });
  };

  document.addEventListener('click', (event) => {
    const launcher = event.target.closest('[data-quiz-launch]');
    if (!launcher) return;
    const quiz = document.querySelector('[data-paddle-quiz]');
    if (!quiz) return;
    event.preventDefault();
    initPaddleQuizzes(document);
    const controller = quiz.pickyQuiz;
    if (!controller) return;
    if (controller.drawer.hidden) controller.open();
    else controller.dialog.scrollTo({ top: 0, behavior: 'smooth' });
  });

  document.addEventListener('shopify:section:load', (event) => {
    initPaddleQuizzes(event.target);
    initHeadingReveals(event.target);
    initDawnImageReveals(event.target);
    event.target.querySelectorAll('[data-product-section]').forEach(updateBenchPages);
  });

  const mobileNavigation = window.matchMedia('(max-width:989px)');
  const setNavigationOpen = (open, restoreFocus = false) => {
    const toggle = document.querySelector('.picky-nav-toggle');
    const nav = toggle && document.getElementById(toggle.getAttribute('aria-controls'));
    if (!toggle || !nav) return;
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
    nav.classList.toggle('is-open', open);
    const backdrop = document.querySelector('[data-nav-backdrop]');
    if (backdrop) backdrop.hidden = !open;
    document.body.classList.toggle('picky-navigation-open', open);
    if (open) {
      const bottom = toggle.closest('header').getBoundingClientRect().bottom;
      document.documentElement.style.setProperty('--picky-nav-top', `${bottom}px`);
    } else {
      nav.querySelectorAll('details[open]').forEach(menu => { menu.open = false; });
    }
    if (restoreFocus) toggle.focus();
  };
  document.addEventListener('pointerdown', event => {
    const toggle = document.querySelector('.picky-nav-toggle[aria-expanded="true"]');
    if (!toggle) return;
    const nav = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!nav?.contains(event.target) && !toggle.contains(event.target)) setNavigationOpen(false);
  });
  document.addEventListener('focusin', event => {
    if (!document.body.classList.contains('picky-navigation-open')) return;
    if (!event.target.closest('.picky-nav, .picky-nav-toggle')) setNavigationOpen(false);
  });
  mobileNavigation.addEventListener('change', () => setNavigationOpen(false));
  document.addEventListener('shopify:section:unload', () => setNavigationOpen(false));

  const closeDrawers = () => {
    drawers.forEach((drawer) => { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); });
    if (overlay) overlay.hidden = true;
    document.body.classList.remove('picky-drawer-open');
    lastTrigger?.focus();
  };

  const openDrawer = (name, trigger) => {
    closeDrawers();
    lastTrigger = trigger;
    const drawer = document.querySelector(`[data-drawer="${name}"]`);
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.hidden = false;
    document.body.classList.add('picky-drawer-open');
    if (name === 'cart') loadCart();
    requestAnimationFrame(() => drawer.querySelector('input, button, a')?.focus());
  };

  const updateCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((badge) => {
      badge.textContent = count;
      badge.hidden = count === 0;
    });
  };

  const renderCart = (cart) => {
    const target = document.querySelector('[data-cart-content]');
    if (!target) return;
    updateCount(cart.item_count);
    if (!cart.items.length) {
      target.innerHTML = `<div class="picky-cart-empty"><p>Your cart is empty. Explore the collection to find your next paddle.</p><button class="picky-button" type="button" data-drawer-close>Continue shopping</button></div>`;
      return;
    }
    const items = cart.items.map((item, index) => `<article class="picky-cart-item">
      <a href="${item.url}">${item.image ? `<img src="${imageFor(item)}" width="184" height="212" alt="${escapeHtml((item.product_title || '').replaceAll('™', ''))}">` : ''}</a>
      <div><a href="${item.url}"><h3>${escapeHtml((item.product_title || '').replaceAll('™', ''))}</h3></a>${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="picky-cart-item__variant">${escapeHtml(item.variant_title)}</p>` : ''}<div class="picky-cart-quantity"><button type="button" data-cart-change="${index + 1}" data-quantity="${item.quantity - 1}" aria-label="Decrease ${escapeHtml((item.product_title || '').replaceAll('™', ''))} quantity">−</button><span>${item.quantity}</span><button type="button" data-cart-change="${index + 1}" data-quantity="${item.quantity + 1}" aria-label="Increase ${escapeHtml((item.product_title || '').replaceAll('™', ''))} quantity">+</button></div></div>
      <div><p class="picky-cart-item__price">${money(item.final_line_price, cart.currency)}</p><button class="picky-cart-remove" type="button" data-cart-change="${index + 1}" data-quantity="0">Remove</button></div>
    </article>`).join('');
    target.innerHTML = `${items}<div class="picky-cart-footer"><div class="picky-cart-subtotal"><span>Subtotal</span><span>${money(cart.total_price, cart.currency)}</span></div><a class="picky-cart-checkout" href="${root}checkout">Checkout</a></div>`;
  };

  const loadCart = async () => {
    const target = document.querySelector('[data-cart-content]');
    if (target) target.innerHTML = '<p class="picky-drawer__loading">Loading cart…</p>';
    try {
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart could not be loaded.');
      renderCart(await response.json());
    } catch (error) {
      if (target) target.innerHTML = `<p class="picky-search-empty">${escapeHtml(error.message)} Please refresh and try again.</p>`;
    }
  };

  const changeCart = async (line, quantity, button) => {
    button.disabled = true;
    try {
      const response = await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) });
      if (!response.ok) throw new Error('Cart update failed.');
      renderCart(await response.json());
    } catch (error) {
      button.disabled = false;
      alert(error.message);
    }
  };

  const quickViewModal = document.querySelector('[data-quick-view-modal]');
  const quickViewContent = document.querySelector('[data-quick-view-content]');
  let quickViewTrigger = null;

  const closeQuickView = () => {
    if (!quickViewModal || quickViewModal.hidden) return;
    quickViewModal.classList.remove('is-open');
    quickViewModal.hidden = true;
    document.body.classList.remove('picky-modal-open');
    quickViewTrigger?.focus();
  };

  const quickAdd = async (variantId, quantity, button) => {
    const original = button.innerHTML;
    button.disabled = true;
    button.textContent = 'Adding…';
    try {
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(quantity) || 1 }] }) });
      if (!response.ok) throw new Error('This item could not be added.');
      button.disabled = false;
      button.innerHTML = original;
      closeQuickView();
      openDrawer('cart', button);
    } catch (error) {
      button.disabled = false;
      button.innerHTML = original;
      alert(error.message);
    }
  };

  const openQuickView = async (url, trigger) => {
    if (!quickViewModal || !quickViewContent) return;
    quickViewTrigger = trigger;
    quickViewContent.innerHTML = '<p class="picky-drawer__loading">Loading product…</p>';
    quickViewModal.hidden = false;
    requestAnimationFrame(() => quickViewModal.classList.add('is-open'));
    document.body.classList.add('picky-modal-open');
    quickViewModal.querySelector('.picky-quick-view__dialog')?.focus();
    try {
      const response = await fetch(`${url.split('?')[0].replace(/\.js$/, '')}.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Product details could not be loaded.');
      const product = await response.json();
      const firstAvailable = product.variants.find((variant) => variant.available) || product.variants[0];
      const variants = product.variants.map((variant) => `<option value="${variant.id}" data-price="${variant.price}" data-available="${variant.available}">${escapeHtml(variant.title)}${variant.available ? '' : ' — Out of stock'}</option>`).join('');
      quickViewContent.innerHTML = `<div class="picky-quick-view__grid"><div class="picky-quick-view__media">${product.featured_image ? `<img src="${product.featured_image}" alt="${escapeHtml((product.title || '').replaceAll('™', ''))}">` : ''}</div><div class="picky-quick-view__details"><p class="picky-quick-view__eyebrow">${escapeHtml(product.type || product.vendor || 'Court-tested gear')}</p><h2 id="QuickViewTitle">${escapeHtml((product.title || '').replaceAll('™', ''))}</h2><p class="picky-quick-view__price" data-quick-view-price>${money(firstAvailable.price)}</p><div class="picky-quick-view__description">${(product.description || '').replaceAll('™', '')}</div>${product.variants.length > 1 ? `<label class="picky-quick-view__label" for="QuickViewVariant">Choose your setup</label><select id="QuickViewVariant" data-quick-view-variant>${variants}</select>` : `<input type="hidden" data-quick-view-variant value="${firstAvailable.id}" data-available="${firstAvailable.available}">`}<div class="picky-quick-view__purchase"><div class="picky-quantity"><button type="button" data-quantity-change="-1" aria-label="Decrease quantity">−</button><input data-quick-view-quantity type="number" min="1" value="1" aria-label="Quantity"><button type="button" data-quantity-change="1" aria-label="Increase quantity">+</button></div><button class="picky-pdp__add" type="button" data-quick-view-add ${firstAvailable.available ? '' : 'disabled'}><span>${firstAvailable.available ? 'ADD TO CART' : 'Out of stock'}</span></button></div><a class="picky-quick-view__full" href="${product.url}">View full product details </a></div></div>`;
      const select = quickViewContent.querySelector('select[data-quick-view-variant]');
      if (select) select.value = String(firstAvailable.id);
    } catch (error) { quickViewContent.innerHTML = `<p class="picky-search-empty">${escapeHtml(error.message)}</p>`; }
  };

  const predictiveSearch = async (query) => {
    const target = document.querySelector('[data-search-results]');
    if (!target) return;
    if (query.length < 2) { target.innerHTML = ''; return; }
    target.innerHTML = '<p class="picky-drawer__loading">Searching…</p>';
    try {
      const url = `${root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,page,article&resources[limit]=8&resources[options][unavailable_products]=last`;
      const response = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Search is temporarily unavailable.');
      const resources = (await response.json()).resources.results;
      const results = [...(resources.products || []), ...(resources.collections || []), ...(resources.pages || []), ...(resources.articles || [])];
      target.innerHTML = results.length ? results.map((item) => `<a class="picky-search-result" href="${item.url}">${item.image ? `<img src="${imageFor(item)}" width="144" height="144" alt="">` : '<span></span>'}<span><strong>${escapeHtml((item.title || '').replaceAll('™', ''))}</strong>${item.price ? `<small>${searchPrice(item.price)}</small>` : `<small>${escapeHtml(item.type || '')}</small>`}</span></a>`).join('') : '<p class="picky-search-empty">No matching gear found.</p>';
    } catch (error) { target.innerHTML = `<p class="picky-search-empty">${escapeHtml(error.message)}</p>`; }
  };

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.picky-paddle-nav[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
    const toggle = event.target.closest('.picky-nav-toggle');
    if (toggle) {
      setNavigationOpen(toggle.getAttribute('aria-expanded') !== 'true');
    }
    if (event.target.closest('.picky-nav a')) setNavigationOpen(false);
    const drawerOpen = event.target.closest('[data-drawer-open]');
    if (drawerOpen) openDrawer(drawerOpen.dataset.drawerOpen, drawerOpen);
    if (event.target.closest('[data-drawer-close]') || event.target === overlay) closeDrawers();
    const cartChange = event.target.closest('[data-cart-change]');
    if (cartChange) changeCart(Number(cartChange.dataset.cartChange), Number(cartChange.dataset.quantity), cartChange);
    const wishlistButton = event.target.closest('[data-wishlist-id]');
    if (wishlistButton) toggleWishlist(wishlistButton);
    const viewButton = event.target.closest('[data-quick-view]');
    if (viewButton) openQuickView(viewButton.dataset.quickView, viewButton);
    if (event.target.closest('[data-quick-view-close]')) closeQuickView();
    const quickViewAdd = event.target.closest('[data-quick-view-add]');
    if (quickViewAdd) {
      const variant = quickViewContent?.querySelector('[data-quick-view-variant]');
      const quantity = quickViewContent?.querySelector('[data-quick-view-quantity]');
      quickAdd(variant?.value, quantity?.value, quickViewAdd);
    }
    const benchPage = event.target.closest('[data-bench-page]');
    if (benchPage) {
      const pagination = benchPage.closest('[data-bench-pagination]');
      const slider = pagination?.previousElementSibling;
      const cards = [...(slider?.querySelectorAll('.picky-bench-card') || [])].filter(card => !card.hidden);
      const perPage = window.innerWidth < 990 ? 1 : 3;
      const target = cards[Number(benchPage.dataset.benchPage) * perPage];
      target?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      pagination.querySelectorAll('[data-bench-page]').forEach((dot) => { const active = dot === benchPage; dot.classList.toggle('is-active', active); active ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'); });
    }
    const filter = event.target.closest('[data-product-section] [data-filter]');
    if (filter) {
      const section = filter.closest('[data-product-section]');
      section.querySelectorAll('[data-filter]').forEach(button => { button.classList.toggle('is-active', button === filter); button.setAttribute('aria-pressed', String(button === filter)); });
      section.querySelectorAll('.picky-bench-card').forEach(card => { card.hidden = filter.dataset.filter !== 'all' && card.dataset.playStyle !== filter.dataset.filter; });
      const slider = section.querySelector('[data-bench-slider]');
      slider?.scrollTo({ left: 0, behavior: 'instant' });
      updateBenchPages(section);
      const count = [...section.querySelectorAll('.picky-bench-card')].filter(card => !card.hidden).length;
      const status = section.querySelector('[data-filter-status]');
      if (status) status.textContent = `${count} ${filter.dataset.filter === 'all' ? '' : filter.textContent.trim() + ' '}paddles shown`;
      initDawnImageReveals(section);
    }
  });

  document.addEventListener('input', (event) => {
    if (!event.target.closest('[data-predictive-search]')) return;
    clearTimeout(searchTimer);
    searchTimer = setTimeout(() => predictiveSearch(event.target.value.trim()), 250);
  });
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-collection-sort]')) event.target.form?.submit();
    if (event.target.matches('[data-variant-select]')) {
      const option = event.target.selectedOptions[0];
      const rootElement = event.target.closest('[data-product-root]');
      const button = rootElement?.querySelector('[data-add-to-cart]');
      const available = option?.dataset.available === 'true';
      const stockLabel = rootElement?.querySelector('[data-stock-label][role="status"]');
      if (stockLabel) stockLabel.textContent = option?.dataset.stockLabel || '';
      const price = rootElement?.querySelector('[data-product-price]');
      if (price) price.textContent = option?.dataset.price || '';
      const amount = rootElement?.querySelector('.picky-money > span');
      if (amount) amount.textContent = option?.dataset.price || '';
      const model = rootElement?.querySelector('[data-product-model]');
      const setup = rootElement?.querySelector('[data-product-setup]');
      if (model) model.textContent = option?.dataset.model || '';
      if (setup) setup.textContent = option?.dataset.setup || '';
      const variantUrl = new URL(location.href); variantUrl.searchParams.set('variant', event.target.value); history.replaceState({}, '', variantUrl);
      if (option?.dataset.imageSrc) {
        const image = rootElement?.querySelector('.picky-pdp__hero-image');
        if (image) { image.removeAttribute('srcset'); image.src = option.dataset.imageSrc; image.alt = option.dataset.imageAlt || ''; applyImageAlignment(image, option.dataset); }
        rootElement?.querySelectorAll('[data-product-thumb]').forEach(t => t.classList.remove('is-active'));
        const index = rootElement?.querySelector('[data-media-index]'); if (index) index.textContent = '—';
      }
      if (button) { button.disabled = !available; button.querySelector('span').textContent = available ? 'ADD TO CART' : (rootElement?.dataset.unavailableLabel || 'Out of stock'); }
    }
    if (event.target.matches('[data-quick-view-variant]')) {
      const option = event.target.selectedOptions[0];
      const button = quickViewContent?.querySelector('[data-quick-view-add]');
      const price = quickViewContent?.querySelector('[data-quick-view-price]');
      const available = option?.dataset.available === 'true';
      if (price) price.innerHTML = money(Number(option?.dataset.price || 0));
      if (button) { button.disabled = !available; button.querySelector('span').textContent = available ? 'ADD TO CART' : 'Out of stock'; }
    }
  });
  document.addEventListener('click', (event) => {
    const quantityButton = event.target.closest('[data-quantity-change]');
    if (quantityButton) {
      const input = quantityButton.parentElement.querySelector('input');
      input.value = Math.max(1, Number(input.value || 1) + Number(quantityButton.dataset.quantityChange));
    }
    const thumb = event.target.closest('[data-product-thumb]');
    if (thumb) {
      const select = thumb.closest('[data-product-root]')?.querySelector('[data-variant-select]');
      if (select && thumb.dataset.variantId) { select.value = thumb.dataset.variantId; select.dispatchEvent(new Event('change', { bubbles: true })); }
      const gallery = thumb.closest('.picky-pdp__gallery');
      const image = gallery?.querySelector('.picky-pdp__hero-image');
      if (image) { image.style.opacity = '0'; setTimeout(() => { image.removeAttribute('srcset'); image.src = thumb.dataset.imageSrc; image.alt = thumb.dataset.imageAlt; applyImageAlignment(image, thumb.dataset); image.style.opacity = '1'; }, 120); }
      gallery?.querySelectorAll('[data-product-thumb]').forEach((item) => item.classList.toggle('is-active', item === thumb));
      const index = gallery?.querySelector('[data-media-index]'); if (index) index.textContent = thumb.dataset.index;
    }
  });
  document.querySelectorAll('[data-product-form]').forEach((form) => form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = form.querySelector('[data-add-to-cart]'); const status = form.querySelector('[data-product-status]');
    button.disabled = true; status.textContent = 'Adding your pick…';
    try { const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) }); if (!response.ok) throw new Error('This item could not be added.'); status.textContent = 'Added to your cart.'; button.disabled = false; openDrawer('cart', button); }
    catch (error) { status.textContent = error.message; button.disabled = false; }
  }));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') { closeQuickView(); closeDrawers(); document.querySelector('[data-paddle-quiz]')?.pickyQuiz?.close(); document.querySelectorAll('.picky-paddle-nav[open]').forEach(menu => { menu.open = false; menu.querySelector('summary')?.focus(); }); const navToggle = document.querySelector('.picky-nav-toggle[aria-expanded="true"]'); if (navToggle) setNavigationOpen(false, true); } });

  document.querySelectorAll('product-recommendations[data-url]').forEach(async (element) => {
    if (element.innerHTML.trim()) return;
    try {
      const response = await fetch(element.dataset.url);
      if (!response.ok) return;
      const html = document.createElement('div');
      html.innerHTML = await response.text();
      const replacement = html.querySelector('product-recommendations');
      if (replacement?.innerHTML.trim()) { element.innerHTML = replacement.innerHTML; syncWishlistButtons(); initHeadingReveals(element); initDawnImageReveals(element); }
    } catch (_) {}
  });
  document.querySelectorAll('[data-bench-slider]').forEach((slider) => {
    let timer;
    slider.addEventListener('scroll', () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const cards = [...slider.querySelectorAll('.picky-bench-card')].filter(card => !card.hidden);
        if (!cards.length) return;
        const nearest = cards.reduce((best, card, index) => Math.abs(card.offsetLeft - slider.scrollLeft) < best.distance ? { index, distance: Math.abs(card.offsetLeft - slider.scrollLeft) } : best, { index: 0, distance: Infinity });
        const page = Math.floor(nearest.index / (window.innerWidth < 990 ? 1 : 3));
        slider.nextElementSibling?.querySelectorAll('[data-bench-page]').forEach((dot, index) => { const active = index === page; dot.classList.toggle('is-active', active); active ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'); });
      }, 80);
    }, { passive: true });
  });
  document.querySelectorAll('[data-product-section]').forEach(updateBenchPages);
  window.addEventListener('resize', () => document.querySelectorAll('[data-product-section]').forEach(updateBenchPages));
  syncWishlistButtons();
  initHeadingReveals();
  initDawnImageReveals();
  initPaddleQuizzes();
})();


document.addEventListener('change', function(event) {
  if (event.target.matches('[data-whatsapp-consent]')) {
    const phone = document.getElementById('PickyClubPhone');
    if (phone) phone.required = event.target.checked;
  }
});


